<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="Dedication-ded"><span class="ePub-I">For my family: ever patient, generous, and supportive in my pursuit of two careers</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?784ba5e6